import { render, staticRenderFns } from "./KabPuncakJaya.vue?vue&type=template&id=3939aed5"
import script from "./KabPuncakJaya.vue?vue&type=script&lang=js"
export * from "./KabPuncakJaya.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports